function update_results_button() {
    var update_results_button = document.querySelector(".update_results_button");
    var update_results_button_moble = document.querySelector(".update_results_button_mobile");
    var closeBtn = document.querySelector(".close_button");
    var sub_button_wraper = document.querySelector(".sub_button_wraper");
    var update_results_button_wrapper = document.querySelector(".update_results_button_wraper");



    update_results_button.addEventListener("click", () => {
        sub_button_wraper.classList.add("active");
    });
    update_results_button_moble.addEventListener("click", () => {
        sub_button_wraper.classList.add("active");
        update_results_button_wrapper.style.flexDirection = "column";
    });

    closeBtn.addEventListener("click", () => {
        sub_button_wraper.classList.remove("active");
        setTimeout(() => {
            update_results_button_wrapper.style.flexDirection = "";
        }, 1000);
    });

}


function getQuestionsection() 
{
	var updateButtons = document.querySelectorAll( ".sub_button" );
	updateButtons.forEach( updateButton => 
	{
		updateButton.addEventListener( "click", () => 
		{
			document.querySelector( ".welleasy_question_popup_overlay" ).classList.add( "open" );
			document.querySelector( ".welleasy_question_popup_wrapper" ).classList.add( "open" );

			var updateButtonName = updateButton.getAttribute( 'data-subbutton' );
			var request = new XMLHttpRequest();	  
			request.addEventListener( 'load', handleResponse );
			request.open( 'GET', '/pages/welleasy-quiz' );
			request.send();
		
			function handleResponse() 
			{
				var newdoc = new DOMParser().parseFromString( this.responseText, "text/html" );
				var quizActions = newdoc.querySelectorAll( ".quiz_action" );

				quizActions.forEach(action => 
				{
					action.innerHTML = '<button class="quiz_started_button popup_button">Update my results</button>';
				});
				
				document.querySelector( ".welleasy_question_popup" ).innerHTML = newdoc.querySelector( '.'+updateButtonName ).innerHTML;
				activeinput();
				updateResult();
			}
		});


	});
}

function updateQueryStringParameter( uri, key, value ) 
{
	var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
	var separator = uri.indexOf('?') !== -1 ? "&" : "?";
	if (uri.match(re)) {
		return uri.replace( re, '$1' + key + "=" + value + '$2' );
	}
	else {
		return uri + separator + key + "=" + value;
	}

}

function updateResult() 
{
	var popupButtons = document.querySelectorAll( ".quiz_action .popup_button" );
	popupButtons.forEach( popupbutton => 
	{
		popupbutton.addEventListener( "click", (e) => 
		{
            var type 			= document.querySelector( ".question_options" ).getAttribute( "data-type" );
            var answerInputs	= document.querySelector( ".question_options" ).querySelectorAll( ".single_option input[type='checkbox']:checked" );
            var answersIdx 	= 1;
            var component 	= "";
            
            var foodAisles		= "&foodAisles=";
            var nonFoodAisles	= "&nonFoodAisles=";

            answerInputs.forEach( function( answer )
            {
                component 		= component + answer.value;

                if( answersIdx != answerInputs.length )
                {
                    component = component + ",";
                }


                if( type == "aisles" && answer.getAttribute( "data-food-collection" ) == "true" )
                {
                    if( foodAisles == "&foodAisles=" )
                    {
                        foodAisles = foodAisles + answer.value;
                    }
                    else
                    {
                        foodAisles = foodAisles + "," + answer.value;
                    }
                }
                else if( type == "aisles" && answer.getAttribute( "data-food-collection" ) == "false" )
                {
                    if( nonFoodAisles == "&nonFoodAisles=" )
                    {
                        nonFoodAisles = nonFoodAisles + answer.value;
                    }
                    else
                    {
                        nonFoodAisles = nonFoodAisles + "," + answer.value;
                    }
                }


                answersIdx = answersIdx + 1;
            } ); 

            if( foodAisles != "&foodAisles=" )
            {
                component 		= component + foodAisles;
            }

            if( nonFoodAisles != "&nonFoodAisles=" )
            {
                component 		= component + nonFoodAisles;
            }

			var updatedUrl = updateQueryStringParameter(window.location.href,type, encodeURIComponent(component));

			window.location.href = updatedUrl;

		});
	});
}
//////////////////
//LOGIC
//////////////////

var g_products      = [ ];
var g_productLookup = { };
var g_excluded      = { };
var g_productQ      = { };
var g_dietAccProducts = [];
var g_dietAccProductsMarkup = [];
var g_randomProducts = [];
var g_quizProducts   = {};
var g_sortedProductData = [];
var g_CollectionData = {};
var g_liquidData	=
{
    "store": "welleasy.co.uk",
    "exhaustive": true,
    "resultLimit": 54,
    "configuredRankings": [
        {
            "ranking_attribute": "collection",
            "ranking_attribute_value": "Home",
            "ranking_value": "120000",
            "number_of_products_to_rank": "5"
        },
        {
            "ranking_attribute": "collection",
            "ranking_attribute_value": "Beauty",
            "ranking_value": "100200",
            "number_of_products_to_rank": "5"
        },
        {
            "ranking_attribute": "collection",
            "ranking_attribute_value": "Supplements",
            "ranking_value": "100200",
            "number_of_products_to_rank": "5"
        }
    ]
}

var MIN_PRODUCTS_BEFORE_RENDER = 40;
var MAIN_PRODUCT_RANK          = 100000;
var PRODUCT_INTERLEAVE_RANK    = 10000;
 
var PRODUCT_TEMPLATE =
`<div class="product-block product-card welleasy-responsive-table-row quiz_product_row" data-handle="__URL__" data-variant-id="__VARIANT_ID__" data-vendor="__VENDOR__">
    <div class="result-product-card">
        <div class="product-block__image-container product_popup_btn">
            <div class="quiz--product-label top-left" style="background: #6BD2CD;">
                <span class="snize-right-arrow" style="border-left-color: #6BD2CD;"></span>__PER_OFF__% off
            </div>
            <div class="global-border-radius hover-images  relative">
                <div class="image-one">
                    <div class="rimage-outer-wrapper" style="max-width: 1080px; max-height: 1080px">
                        <div class="rimage-wrapper " >
                            <img class="rimage__image fade-in lazyautosizes lazyload" src="" data-src="__IMGURL__">
                        </div>
                    </div>
                </div>
           </div>
        </div>
        <div class="product-summary__card_content">
            <div class="product-summary__content product_popup_btn">
                <div class="product-summary__title">
                    <h1>__TITLE__</h1>
                </div>
            </div>
            <div class="product_brand">__BRAND__</div>
            <div class="order-history-order-price">
                <span class="price">__PRICE__</span>
                <span class="compare--price">__COM_PRICE__</span>
            </div>
            <div class="order-history-addToCart-button">
                <button class="order-history-addToCart snize-button" data-product-id="__ID__" data-variant-id="__VARIANT_ID__">
                    <span class="btn__label">Add to cart</span>
                </button>
            </div>                                        
        </div>
   </div>
</div>`;



function InsertSortedRanged( ar, start, end, entry, comp, options )
{
    var size = end - start;
    if ( size < 3 )
    {
        // when there are only a few elements just check and decide
        for ( var i = start; i < end; i++ )
        {
            var compval = comp( entry, ar[ i ] );

            if ( compval == 0 )
            {
                if ( ( options ) && ( options.allowDuplicateKeys ) )
                {
                    ar.splice( i, 0, entry );
                }
                else
                {
                    ar[ i ] = entry;
                }
                break;
            }
            else if ( compval < 0 )
            {
                ar.splice( i, 0, entry );
                break;
            }
        }
        if ( i == end )
        {
            ar.splice( i, 0, entry );
        }
        if ( ( options ) && ( options.notifier ) )
        {
            options.notifier( entry, i );
        }
    }
    else
    {
        var idx     = Math.floor( start + ( size / 2 ) );
        var check   = ar[ idx ];
        var compval = comp( entry, check );
        if ( compval == 0 )
        {
            // special case for equality
            if ( ( options ) && ( options.allowDuplicateKeys ) )
            {
                ar.splice( idx, 0, entry );
            }
            else
            {
                ar[ idx ] = entry;
            }
            if ( ( options ) && ( options.notifier ) )
            {
                options.notifier( entry, idx );
            }
        }
        else if ( compval < 0 )
        {
            // partition left
            InsertSortedRanged( ar, start, idx, entry, comp, options );
        }
        else
        {
            // partition right
            InsertSortedRanged( ar, idx, end, entry, comp, options );
        }
    }
}
function InsertionSort( ar, entry, comp, options )
{
    if ( ar.length == 0 )
    {
        ar.push( entry );
    }
    else
    {
        InsertSortedRanged( ar, 0, ar.length, entry, comp, options );
    }
}

function ParseQP( )
{
    var qpd   = { };
    var qp    = decodeURIComponent( window.location.search.substr( 1 ) );
    var pairs = qp.split( "&" );

    for ( var i = 0; i < pairs.length; i++ )
    {
        var tuple = pairs[ i ].split( "=" );
        if ( ( tuple ) && ( tuple.length == 2 ) )
        {
            var key  = tuple[ 0 ];
            var val  = tuple[ 1 ];
            qpd[ key ] = decodeURIComponent( val );
        }
    }

    return ( qpd );
}
function SendAPIRequest( url, method, payload, cb )
{
    var xhr = new XMLHttpRequest( );
    xhr.timeout = 5000;

    xhr.onreadystatechange = function( )
    {
        if ( xhr.readyState == 4 )
        {
            var response;
            var err;
            if ( xhr.status == 200 )
            {
                if ( ( xhr.responseText ) && ( xhr.responseText.length > 0 ) )
                {
                    try
                    {
                        response = JSON.parse( xhr.responseText );
                    }
                    catch ( e )
                    {
                        console.log( "error parsing response : " + e.stack );
                        err = { "error" : e };
                    }
                }
            }
            else
            {
                err = { "error" : xhr.status };

                if ( ( xhr.responseText ) && ( xhr.responseText.length > 0 ) )
                {
                    try
                    {
                        err.detail = JSON.parse( xhr.responseText );
                    }
                    catch ( e )
                    {
                    }
                }
            }

            cb( err, response, xhr );
        }
    };


    if ( ( method != "GET" ) && ( payload ) )
    {
        xhr.open( method, url, true );
        xhr.setRequestHeader( "Content-Type", "application/json" );
        xhr.send( JSON.stringify( payload ) );
    }
    else
    {
        if ( payload )
        {
            var qpStr = "?";
            for ( var key in payload )
            {
                if ( qpStr.length > 1 )
                {
                    qpStr += "&";
                }
                qpStr += key + "=" + encodeURIComponent( payload[ key ] );
            }
            xhr.open( method, url, true );
        }
        else
        {
            xhr.open( method, url, true );
        }

        xhr.setRequestHeader( "Content-Type", "application/json" );
        xhr.send( );
    }
}
  
function initProductSlider(type) 
{
    // if (type.includes( '&' )) 
    // {
    //     var type = type.replaceAll( " & ", "-" ).replaceAll( ", ", "-" );
    // }
    // else
    // {
    // }
    var type = type.replaceAll( " ", "-" );
    if ( $( '.welleasy-responsive-table-row' ).length > 1 )
	{
        var root     = `.welleasy-quiz-result-target[data-for="${type}"]`;
        var selector = `${root} .welleasy-responsive-table-row`;
        
        if ( $(selector).length == 10 )
        {
            console.log("responsive-table-row: "+ type, $(selector).length);
            $(root).slick({
                dots: false,
                infinite: false,
                arrows: true, 
                prevArrow:'<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button" aria-disabled="false" style="display: inline-block;"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" version="1.1" id="Layer_1" viewBox="0 0 492 492" xml:space="preserve"><g><g><path d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12    C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084    c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864    l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z"/></g></g></svg></button>',
                speed: 300,
                slidesToShow: 8,
                slidesToScroll: 1,
                adaptiveHeight: true,
                smoothScroll: true,
                responsive: 
                [
                    {
                        breakpoint: 1400,
                        settings: 
                        {
                            slidesToShow: 6,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: 
                        {
                            slidesToShow: 4.5,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: 
                        {
                            slidesToShow: 3.5,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: 
                        {
                            slidesToShow: 2.5,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: 
                        {
                            slidesToShow: 2.5,
                            slidesToScroll: 2
                        }
                    }
                ]
                
            });

            $('.welleasy-quiz-result-target[data-for="'+type+'"]').parent().find('.order-history-show_more').on( "click", function(e) 
            {
                e.preventDefault();
                var lastSlideIndex = $( '.welleasy-quiz-result-target[data-for="'+type+'"]' ).find( '.slick-slide' ).length - 1;
                var activeslideIndex = $( '.welleasy-quiz-result-target[data-for="'+type+'"]' ).find( '.slick-active' ).length - 1;
                
                
                $( '.welleasy-quiz-result-target[data-for="'+type+'"]' ).slick( 'slickGoTo', lastSlideIndex - activeslideIndex );
                $( this ).parents( ".welleasy-quiz-result-show-more" ).addClass('hidden' );

            });

            $( '.welleasy-quiz-result-target[data-for="'+type+'"]' ).on( 'afterChange', function( event, slick, currentSlide )
            {
                var slick_index = $( ".welleasy-quiz-result-target[data-for='" + type + "'] [data-slick-index='9']" );
                if ( slick_index.hasClass("slick-active") ) 
                {        
                    $(this).parent().find( ".welleasy-quiz-result-show-more" ).addClass( 'hidden' );
                }
                else
                {
                    $(this).parent().find( ".welleasy-quiz-result-show-more" ).removeClass( 'hidden' );
                }
            });

        }
    }
}

function CreateProductDOM( product )
{
    var productVariation = product.variants[ 0 ];

    var perOff = Math.abs(Math.ceil( ( ( productVariation.price / productVariation.compare_at_price) - 1) * 100));

    function truncateString(str, num, ending = ' ') 
    {
        return str.length > num ? str.slice(0, num) + ending : str;
    }

    var markup = PRODUCT_TEMPLATE.replaceAll('__ID__',product.id)
                  .replaceAll('__TITLE__',product.title) 
                  .replaceAll('__BRAND__',product.vendor)
                  .replaceAll('__PRICE__',productVariation.priceAsMoney)
                  .replaceAll('__COM_PRICE__',productVariation.compare_at_priceAsMoney)
                  .replaceAll('__IMGURL__',product.featured_image)
                  .replaceAll('__URL__','/products/'+product.handle)
                  .replaceAll('__PER_OFF__',perOff)
                  .replaceAll('__VARIANT_ID__',productVariation.id);

    if(perOff < 1 || isNaN(perOff) )
    {
        markup = markup.replaceAll("quiz--product-label","hidden");
    }

    var parser = document.createElement( "div" );
    parser.innerHTML = markup;

    //remove per off if it doesnt have a discount

    return ( parser.firstChild );
   
}

function GetConfiguredRanking( type, response, product )
{
    var configuredRankings           = g_liquidData.configuredRankings;
    var configuredRankingResponse   = { "hasConfiguredRanking" : false };

    if( configuredRankings && configuredRankings.length > 0 )
    {
        for( var i = 0; i < configuredRankings.length; i++ )
        {
            var configuredRanking       = configuredRankings[ i ];
            var numberOfProductsToRank  = Number( configuredRanking.number_of_products_to_rank );
            if( numberOfProductsToRank > 0 )
            {
                if( configuredRanking.ranking_attribute == "type" && type == configuredRanking.ranking_attribute_value )
                {
                    configuredRankingResponse.hasConfiguredRanking  = true;
                    configuredRankingResponse.ranking               = configuredRanking.ranking_value;

                    g_liquidData.configuredRankings[ i ].number_of_products_to_rank = numberOfProductsToRank--;
                    break;
                }
                else if( configuredRanking.ranking_attribute == "collection" && response.collection.title == configuredRanking.ranking_attribute_value )
                {
                    configuredRankingResponse.hasConfiguredRanking  = true;
                    configuredRankingResponse.ranking               = configuredRanking.ranking_value;

                    g_liquidData.configuredRankings[ i ].number_of_products_to_rank = numberOfProductsToRank - 1;
                    break;
                }
                else if( configuredRanking.ranking_attribute == "vendor" && product.vendor == configuredRanking.ranking_attribute_value )
                {
                    configuredRankingResponse.hasConfiguredRanking  = true;
                    configuredRankingResponse.ranking               = configuredRanking.ranking_value;

                    g_liquidData.configuredRankings[ i ].number_of_products_to_rank = numberOfProductsToRank--;
                    break;
                }                
            }
        }
    }

    return configuredRankingResponse;
}

// to do - could apply various ranking algorithms here
// but : it's really easy to end up just showing (for example) the first ten keto products, because they have higher
// weighting than "type" or "vendor" attributes...
function ProductRank( type, counter, response, product )
{
    var rank = MAIN_PRODUCT_RANK;


    //WE Want the ability to merchandise certian products. ie if a customer selects Supplements then there should be x number of suplement products that show on the first page.
    //The variable below checks to see if the response, type, product match that configured in the theme and if so ranks them based on the ranking value set.
    var configuredRanking = GetConfiguredRanking( type, response, product );

    if( configuredRanking.hasConfiguredRanking )
    {
        rank = configuredRanking.ranking_value;
    }
    // use the product position in its original collection to interleave products from multiple subcategories
    else if ( type != "dietary" )
    {
        rank += counter.value;
    }


    return ( rank );
}

function QuizSorter( a, b )
{
    return ( b.rank - a.rank );
}

function getRandomItem(arr, n) {
    var result = new Array(n),
        len = arr.length,
        taken = new Array(len);
    if (n > len){
        return result;
    }
    while (n--) {
        var x = Math.floor(Math.random() * len);
        result[n] = arr[x in taken ? taken[x] : x];
        taken[x] = --len in taken ? taken[len] : len;
    }
    return result;
}

function RenderProducts( )
{
    var sorted = [ ];
    g_products.forEach( function( entry )
    {
        InsertionSort( sorted, entry, QuizSorter, { "allowDuplicateKeys" : true } );
    } );

    var target = document.querySelector( ".welleasy-quiz-result-target" );

    while ( target.firstChild )
    {
        target.lastChild.remove( );
    }

    if(g_randomProducts.length > 0) {
        g_randomProducts = getRandomItem(g_randomProducts, 5);
        for(var i = 0; i < g_randomProducts.length; i++){
            var add = {
                "node" : CreateProductDOM( g_randomProducts[i] ),
                "rank" : 0
            }
            add.node.setAttribute( "data-rank", add.rank );
            target.appendChild( add.node );
        }
        g_liquidData.resultLimit = g_liquidData.resultLimit - 5;
    }

    var end = sorted.length;
    if ( end > g_liquidData.resultLimit )
    {
        end = g_liquidData.resultLimit;
    }
    for ( var i = 0; i < end; i++ )
    {
        sorted[ i ].node.setAttribute( "data-rank", sorted[ i ].rank );
        target.appendChild( sorted[ i ].node );
    }

    var loadingText = document.querySelector('.loading-text');
    loadingText.remove();
    console.log("loading bar remove");
    document.querySelector(".progress").style.display = "none";
    document.querySelector(".quiz-label").style.display = "block";
    document.querySelector(".quiz-label_subheading").style.display = "block";
}

function RankOneProduct( response, product, type, counter )
{
    counter.value--;

    if ( product.available )
    {
        if ( g_productLookup[ product.id ] == undefined )
        {
            var add =
            {
                "node" : CreateProductDOM( product ),
                "rank" : 0
            };
            g_productLookup[ product.id ] = add;
            g_products.push( add );
        }
        else
        {
            g_productLookup[ product.id ].node.remove( );
        }
        var entry   = g_productLookup[ product.id ];
        entry.rank += ProductRank( type, counter, response, product );
    }
}


function RankProducts( response, type, counter )
{
    if ( ( response ) && ( response.products ) )
    {
        if ( type == "dietary" )
        {
            response.products.forEach( function( product )
            {
                RankOneProduct( response, product, type, counter );

                if ( g_productQ[ product.id ] )
                {
                    g_productQ[ product.id ].forEach( function( entry )
                    {
                        RankOneProduct( response, product, entry.type, counter );
                    } );
                    g_productQ[ product.id ] = undefined;
                }
            } );
        } else if(type == 'random'){

            g_randomProducts = Array.from(new Set(g_randomProducts.concat(response.products)))

        }
        else
        {
            response.products.forEach( function( product )
            {
                if ( ( g_productLookup[ product.id ] ) || ( g_liquidData.unfiltered ) )
                {
                    RankOneProduct( response, product, type, counter );
                }
                else if ( g_excluded[ product.id ] )
                {
                    // previously excluded, ignore (tbd)
                }
                else
                {
                    if ( g_productQ[ product.id ] == undefined )
                    {
                        g_productQ[ product.id ] = [ ];
                    }

                    g_productQ[ product.id ].push( { "type" : type, "product" : product } );
                }
            } );
        }
    }

    if (( !( g_liquidData.exhaustive ) ) )
    {
        // to do : there must be a way to quickly move the one product that's changed from its current position to its new one
        RenderProducts( );
    }
}


function RunFetch( collection, url, type, counter, rank, getProductsInCollection, dataType , cb )
{
    SendAPIRequest( url, "GET", null, function( err, response )
    {
        if ( response )
        {
            console.log( "got response for " + type + " : ", response );
            if( rank == false )
            {
                AddProductToGlobalData( collection, response, dataType );

                if( getProductsInCollection )
                {
                    console.log( "GETTING PRODUCTS IN COLLECTION FOR COLLECTION: " + collection );
                    GetProductsInCollection( collection, response, cb );
                }
                else
                {
                    cb( );
                }

                // if ( ( response ) && ( response.pagination ) && ( response.pagination.next ) &&
                // 	( ( g_products.length < 200 ) || ( g_liquidData.exhaustive ) ) )
                // {
                // 	RunFetch( collection, response.pagination.next, type, counter, false, cb );
                // }
                // else
                // {
                //     cb( );
                // }
            }
            // else
            // {
            // 	RankProducts( response, type, counter );
            // 	if ( ( response ) && ( response.pagination ) && ( response.pagination.next ) &&
            // 		( ( g_products.length < 200 ) || ( g_liquidData.exhaustive ) ) )
            // 	{
            // 		RunFetch( collection, response.pagination.next, type, counter, true, cb );
            // 	}
            // 	else if ( g_liquidData.exhaustive )
            // 	{
            // 		cb( );
            // 	}
            // }

            // initProductSlider();
            // $(window).on('resize', function() 
            // {
            //     initProductSlider();
            // });
        }
        else
        {
            cb( );
        }
		
    } );
}

function GetProductsInCollection( collection, response, cb )
{
    var asyncs = 0;
    function Done( )
    {
        asyncs--;
        if ( ( asyncs == 0 ) )
        {
            cb();
        }
    }
    response.products.forEach( function( product )
    {
        asyncs++;
        //var url = "https://" + g_liquidData.store + "/products/" + product.handle + ".json"
        var url = "/products/" + product.handle + ".json"
        SendAPIRequest( url, "GET", null, function( err, productResponse )
        {
            if ( productResponse )
            {
                AddProductResponseToGlobalData( collection, productResponse );
            }
            Done();
        } );

    } );
}

function AddProductResponseToGlobalData( collection, productResponse )
{
    var quizProducts = g_quizProducts[ collection ];
    for( var i = 0; i < quizProducts.length; i++ )
    {
        var quizProduct = quizProducts[ i ];

        if( quizProduct.id == productResponse.product.id  )
        {
            g_quizProducts[ collection ][ i ] = productResponse.product;
        }
    }
}

function AddProductToGlobalData( collection, response, dataType )
{
    if(dataType == "diet")
    {
        g_quizProducts[ collection + "-diet" ] = response.products;
    }
    else if(dataType == "vendor")
    {
        g_quizProducts[ collection + "-vendor" ] = response.products;
    }
    else
    {
        g_quizProducts[ collection ] = response.products;
    }

	response.products.forEach( function( product )
	{
		if ( product.available )
		{
			if ( g_productLookup[ product.id ] == undefined )
			{
				var add =
				{
					"node" : CreateProductDOM( product ),
					"rank" : 0
				};
				g_productLookup[ product.id ] = add;
				g_products.push( add );
			}
			else
			{
				g_productLookup[ product.id ].node.remove( );
			}
			var entry   = g_productLookup[ product.id ];
		}
	} );

    g_CollectionData[ collection ] = response.collection;
    
}

function Handleise( str )
{
    return ( str.toLowerCase( ).replace( /\s/g, "-" ) );
}

function FetchProducts( collection, type, rank, options, getProductsInCollection, dataType, cb )
{

    // if (collection.includes('_')) 
    // {
    //     collection = collection.toLowerCase( ).replaceAll( '_', "-" );
        
    // }
    //var url = "https://" + g_liquidData.store + "/collections/" + Handleise( collection ) + "?view=json";
    var url = "/collections/" + Handleise( collection ) + "?view=json";
	
	if( options )
	{
		for( field in options )
		{
			url = url + "&" + encodeURIComponent( field ) + "=" + encodeURIComponent( options[ field ] );
		}
	}

    RunFetch( collection, url, type, { "value" : PRODUCT_INTERLEAVE_RANK }, rank, getProductsInCollection, dataType , cb );
}

function Unhandlise( str )
{
    return ( str.replaceAll( "-", " & " ) );
}

function SetupShopButton(replacement, collection) 
{

    var span = document.querySelector(replacement);
    var show = Unhandlise(collection);
    var link = span.closest("a");
    var href = link.getAttribute("href");
    collection = collection.toLowerCase();
    link.setAttribute("href", href + collection);
    span.innerText = show;
    if (collection == 'gluten-free' || collection == 'dairy-free'){
        link.addClass("hide");
        link.hide();
    }
    setTimeout(function () {
        link.removeAttribute("style");
    }, 7000);

}

function FetchQuizResults( )//START
{
    var qp = ParseQP( );

    console.log( "fetching quiz results : ", qp );

	var randomBrandFromAnswers 	= RandomCollection( "vendor", qp );

    var dietQP = qp.diet;

    var diets = dietQP.split(",");

    var randomDietFromAnswers = [];

    diets.forEach(function(diet)
    {
        
        if(diet.includes("_FC"))
        {
            randomDietFromAnswers.push(diet.split("_")[0]);
        }
        else
        {
            randomDietFromAnswers.push(diet);
        }

    })

    qp.diet = qp.diet.replace("_FC", "");

    var randomAislesFromAnswers = RandomAisleCollections( "aisles", qp );

    var asyncs = 1;

    function Done( )
    {
        asyncs--;

        console.log( "async op done, " + asyncs + " remaining" );
        if ( ( asyncs == 0 ) && ( g_liquidData.exhaustive ) )
        {
            PrepareData( qp, randomBrandFromAnswers, randomDietFromAnswers, randomAislesFromAnswers, function()
            {
                document.getElementById("welleasy-quiz-loading-overlay").classList.add("hidden")
            } );
            
            // RenderProductsV2( randomBrandFromAnswers, ranomDietFromAnswers );
        }
    }

    if( qp.vendor )
    {
        var vendors = qp.vendor.split( "," );
        vendors.forEach( function( vendor )
        {
            asyncs++;
            FetchProducts( vendor, null, false, { "sort_by" : "best-selling", "limit" : 100 }, false, "vendor", Done );
        } );
    }
    if( qp.diet )
    {
        var diets = qp.diet.split( "," );
        diets.forEach( function( diet )
        {
            asyncs++;
            FetchProducts( diet, null, false, { "sort_by" : "best-selling", "limit" : 100 }, false, "diet" , Done );
        } );
    }
    if( qp.aisles )
    {
        if( randomAislesFromAnswers.foodAisles && randomAislesFromAnswers.foodAisles.length > 0 )
        {
            var aisles = randomAislesFromAnswers.foodAisles;
            aisles.forEach( function( aisle )
            {
                asyncs++;
                FetchProducts( aisle, null, false, { "sort_by" : "best-selling", "limit" : 100 }, true, false, Done );
            } );
        }

        if( randomAislesFromAnswers.nonFoodAisles && randomAislesFromAnswers.nonFoodAisles.length > 0 )
        {
            var aisles = randomAislesFromAnswers.nonFoodAisles;
            aisles.forEach( function( aisle )
            {
                asyncs++;
                FetchProducts( aisle, null, false, { "sort_by" : "best-selling", "limit" : 100 }, false, false, Done );
            } );
        }
    }

    if( qp.saving_price )
    {
        var saving_price = parseInt(qp.saving_price);
         Saving_prices_counter(saving_price)
    }
    asyncs++;
    FetchProducts( "getting-started", null, false, { "sort_by" : "best-selling", "limit" : 10 }, false, false, Done );



    // if ( qp.collection )
    // {
    //     var collections = qp.collection.split( "," );
    //     if ( collections.length == 0 )
    //     {
    //         g_liquidData.unfiltered = true;
    //     }
    //     else
    //     {
    //         collections.forEach( function( c )
    //         {
    //             asyncs++;
    //             FetchProducts( c, "dietary", true, Done );
    //         } );
    //         setTimeout(function (){
    //             SetupShopButton(".dietary_replacement", collections[0]);
    //         },7000);

    //         /* window.addEventListener("load", function () {
    //             SetupShopButton(".dietary_replacement", collections[0]);
    //         });*/
    //     }
    // }
    // else
    // {
    //     g_liquidData.unfiltered = true;
    // }

    // if ( qp.type )
    // {
    //     var types = qp.type.split( "," );
    //     if ( types.length > 0 )
    //     {
    //         var getRandomProducts = false;
    //         var randomProductFrom = ["Supplements", "Beauty", "Cleaning"]
    //         types.forEach( function( c )
    //         {
    //             asyncs++;
    //             if ( randomProductFrom.includes(c) ) {
    //                 getRandomProducts = true;
    //             }
    //             FetchProducts( c, "type", true, Done );
    //         } );

    //         if(getRandomProducts){
    //             randomProductFrom.forEach( function( c )
    //             {
    //                 asyncs++;
    //                 FetchProducts( c, "random", true, Done );
    //             } );

    //         }
    //         setTimeout(function (){
    //             SetupShopButton(".type_replacement", types[0]);
    //         }, 7000);
    //         /*window.addEventListener("load", function () {
    //             SetupShopButton(".type_replacement", types[0]);
    //         });*/
    //     }
    // }
    // if ( qp.vendor )
    // {
    //     var vendors = qp.type.split( "," );
    //     vendors.forEach( function( c )
    //     {
    //         asyncs++;
    //         FetchProducts( c, "vendor", true, Done );
    //     } );
    // }
    Done( );
}



function Saving_prices_counter(saving_price) {
    console.log(saving_price);
  
    var patt = /(\D+)?(\d+)(\D+)?(\d+)?(\D+)?/;
    var time = 700;
  
    var counterPrice = JSON.parse(document.querySelector("[data-counter-price]").innerHTML);
    var counteritems = counterPrice.counter;
  
    let threshold1, threshold2, threshold3, threshold4, threshold5;
  
    for ( let i = 0; i < counteritems.length; i++ ) 
    {
        var counteritem = counteritems[i];
        threshold1 = parseInt( counteritem.threshold1 );
        threshold2 = parseInt( counteritem.threshold2 );
        threshold3 = parseInt( counteritem.threshold3 );
        threshold4 = parseInt( counteritem.threshold4 );
        threshold5 = parseInt( counteritem.threshold5 );
    }
  
    if ( saving_price == 1 ) 
    {
        saving_price = threshold1;
    } 
    else if ( saving_price == 2 ) 
    {
        saving_price = threshold2;
    } 
    else if ( saving_price == 3 ) 
    {
        saving_price = threshold3;
    } 
    else if ( saving_price == 4 ) 
    {
        saving_price = threshold4;
    } 
    else if ( saving_price >= 5 ) 
    {
        saving_price = threshold5;
    }
  
    var savingsElements = document.querySelectorAll( ".savings" );
  
    savingsElements.forEach((element) => 
    {
        element.innerText = saving_price;
    });
  }
  
function PrepareData( qp, randomBrandFromAnswers, ranomDietFromAnswers, randomAislesFromAnswers, cb )
{
    var brandProducts           = GetBrandProducts( randomBrandFromAnswers);
    // console.log("LENGTH???????????????")
    // console.log(dietProducts)

    if( ranomDietFromAnswers && ranomDietFromAnswers.length > 0 )
    {
        ranomDietFromAnswers.forEach( function( selected_diet )
        {
            console.log("RENDERING DIET PRODUCTS___________________________")
            var dietProducts = GetDietProducts( qp, selected_diet );
            
            if( dietProducts && dietProducts.length > 0 && dietProducts.length >= 10 )
            {
                var target  = document.querySelector( '.welleasy-quiz-products-results[data-type="diet"]' );
                var markup  = '<div class="welleasy-quiz-products-results" data-type="diet" data-typevalue="' + selected_diet + '">';
                markup      +=      '<h1 class="welleasy-quiz-products-diet-name product-result-title"></h1>';
                markup      +=      '<div class="welleasy-quiz-result-wrapper">';
                markup      +=          '<div class="welleasy-quiz-result-show-more"></div>';
                markup      +=          '<div class="welleasy-quiz-result-target" data-for="' + selected_diet + '"></div>';
                markup      +=      '</div>';
                markup      += '</div>';
    
                var parser  = new DOMParser();
                var parsed  = parser.parseFromString( markup, "text/html" ).querySelector( '.welleasy-quiz-products-results[data-type="diet"]' );
                target.appendChild( parsed );
    
                ReallyRenderProducts( "[data-for='" + selected_diet + "']", null, dietProducts, selected_diet, selected_diet );
            }
            // ReallyRenderProducts( "[data-for='diet']", null, dietProducts, 'diet', ranomDietFromAnswers, randomDietTitles );
        });
    }

    if( brandProducts && brandProducts.length > 0 && brandProducts.length >= 10 )
    {
        ReallyRenderProducts( "[data-for='vendor']", null, brandProducts, 'vendor', "My Brands" );
    }

    if( randomAislesFromAnswers.nonFoodAisles && randomAislesFromAnswers.nonFoodAisles.length > 0 )
    {
        randomAislesFromAnswers.nonFoodAisles.forEach( function( nonFoodAisle )
        {
            var aisleProducts = GetAisleProducts( qp, nonFoodAisle, "nonFood" );
            
            if( aisleProducts && aisleProducts.length > 0 && aisleProducts.length >= 10)
            {
                var target  = document.querySelector( ".welleasy-quiz-product-aisle-results-parent" );
                var markup  = '<div class="welleasy-quiz-products-results" data-type="aisle" data-typevalue="' + nonFoodAisle + '">';
                markup      +=      '<h1 class="welleasy-quiz-products-diet-name product-result-title"></h1>';
                markup      +=      '<div class="welleasy-quiz-result-wrapper">';
                markup      +=          '<div class="welleasy-quiz-result-show-more"></div>';
                markup      +=          '<div class="welleasy-quiz-result-target" data-for="' + nonFoodAisle + '"></div>';
                markup      +=      '</div>';
                markup      += '</div>';
    
                var parser  = new DOMParser();
                var parsed  = parser.parseFromString( markup, "text/html" );
                target.appendChild( parsed.documentElement );
    
                ReallyRenderProducts( "[data-for='" + nonFoodAisle + "']", null, aisleProducts, 'aisle', nonFoodAisle );
            }
        } );
    }

    if( randomAislesFromAnswers.foodAisles && randomAislesFromAnswers.foodAisles.length > 0 )
    {
        randomAislesFromAnswers.foodAisles.forEach( function( foodAisle )
        {
            var actual_foodAisle_title = foodAisle;
            // if (foodAisle.includes( '_' )) 
            // {

            //     foodAisle = foodAisle.replaceAll( '_', '-' );
            // }
            var aisleProducts = GetAisleProducts( qp, foodAisle, "food" );
            
            if( aisleProducts && aisleProducts.length > 0 && aisleProducts.length >= 10)
            {
                var target  = document.querySelector( ".welleasy-quiz-product-aisle-results-parent" );
                var markup  = '<div class="welleasy-quiz-products-results" data-type="aisle" data-typevalue="' + foodAisle + '">';
                markup      +=      '<h1 class="welleasy-quiz-products-diet-name product-result-title"></h1>';
                markup      +=      '<div class="welleasy-quiz-result-wrapper">';
                markup      +=          '<div class="welleasy-quiz-result-show-more"></div>';
                markup      +=          '<div class="welleasy-quiz-result-target" data-for="' + foodAisle + '"></div>';
                markup      +=      '</div>';
                markup      += '</div>';
    
                var parser  = new DOMParser();
                var parsed  = parser.parseFromString( markup, "text/html" );
                target.appendChild( parsed.documentElement );
    
                // ReallyRenderProducts( "[data-for='" + foodAisle + "']", null, aisleProducts, 'aisle', actual_foodAisle_title );  
                ReallyRenderProducts( "[data-for='" + foodAisle + "']", null, aisleProducts, 'aisle', foodAisle );  
            }
        } );
    }

    var allBestSellers = GetAllBestSellerProducts( "getting-started" );

    // console.log("ALL BEST3333333333333333333333")
    // console.log(allBestSellers)

    if( allBestSellers && allBestSellers.length > 0 && allBestSellers.length >= 10)
    {
        ReallyRenderProducts( "[data-for='all']", null, allBestSellers, 'all', "Member Favourites" );
    }

    getProductData();
    cb();
}

function ShowImages( selector )
{
    var images = document.querySelectorAll( selector + " img" );
    images.forEach( function( image )
    {
        var dataSrc = image.getAttribute( "data-src" );
        if( dataSrc )
        {
            image.setAttribute( "src", dataSrc );
        }
    } );
}

function AppendShowmore(typevalue)
{
    
    var showMore = 
    `<div class="product-block product-card brand-product-card welleasy-responsive-table-row quiz_product_row" data-variant-id="__VARIANT_ID__" data-vendor="__VENDOR__">
        <div class="result-product-card">
            <div class="product-block__image-container">
                <div class="global-border-radius hover-images  relative">
                    <div class="image-one">
                        <div class="rimage-outer-wrapper" style="max-width: 1080px; max-height: 1080px">
                            <div class="rimage-wrapper"  padding-bottom: 30px;">
                                <img class="brand__image fade-in lazyautosizes lazyload" src="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="product-summary__card_content">
                <div class="order-history-show_more-button">
                    <button class="order-history-show_more snize-button" >
                        <span class="btn__label">
                            Show More
                            </span>
                            <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.69349 5.20238H4.91075V7.98512C4.91075 8.13273 4.85212 8.27429 4.74775 8.37866C4.64337 8.48303 4.50181 8.54167 4.35421 8.54167C4.2066 8.54167 4.06504 8.48303 3.96067 8.37866C3.8563 8.27429 3.79766 8.13273 3.79766 7.98512V5.20238H1.01492C0.867316 5.20238 0.725756 5.14375 0.621383 5.03937C0.51701 4.935 0.458374 4.79344 0.458374 4.64583C0.458374 4.49823 0.51701 4.35667 0.621383 4.2523C0.725756 4.14792 0.867316 4.08929 1.01492 4.08929H3.79766V1.30655C3.79766 1.15894 3.8563 1.01738 3.96067 0.913009C4.06504 0.808636 4.2066 0.75 4.35421 0.75C4.50181 0.75 4.64337 0.808636 4.74775 0.913009C4.85212 1.01738 4.91075 1.15894 4.91075 1.30655V4.08929H7.69349C7.8411 4.08929 7.98266 4.14792 8.08703 4.2523C8.1914 4.35667 8.25004 4.49823 8.25004 4.64583C8.25004 4.79344 8.1914 4.935 8.08703 5.03937C7.98266 5.14375 7.8411 5.20238 7.69349 5.20238Z" fill="black"/>
                            </svg>
                    </button>
                </div>                                        
            </div>
        </div>
    </div>`;
    
    var parser          = new DOMParser();
    var parsedShowMore  = parser.parseFromString(showMore, 'text/html');
    var showMoreElement = parsedShowMore.querySelector('.product-block');

    var target_element = document.querySelector('.welleasy-quiz-products-results[data-typevalue="'+typevalue+'"] .welleasy-quiz-result-show-more');
    target_element.appendChild(showMoreElement)
    

    var brandinfo    = document.querySelector( "[data-brand-info]" );
    brandinfo        = JSON.parse( brandinfo.innerHTML );
    var branditems   = brandinfo.Showbrand
    
    for (let i = 0; i < branditems.length; i++) 
    {
        var branditem = branditems[i];
        var brandImage  = branditem.brand_image;
        var brandName = branditem.brand_name.toLowerCase();
        var CollectionName = document.querySelector( ".welleasy-quiz-products-brand-name" ).innerText.toLowerCase();
        if ( brandName == CollectionName ) 
        {
            document.querySelector( ".welleasy-quiz-products-results[data-type='vendor'] .brand__image" ).src = brandImage;  
            
        }

    }

}



function GetBrandProducts( randomBrandFromAnswers )
{
    var brandProducts   = [];
    var products        = g_quizProducts[ randomBrandFromAnswers + "-vendor" ];

    // console.log(products)

    // if( products && products.length > 0 )
    // {
    //     for( var i = 0; i < products.length; i++ )
    //     {
    //         var product     = products[ i ];
    //         var productNode = g_productLookup[ product.id ];
    
    //         if( brandProducts.length == 10 )
    //         {
    //             break;
    //         }
    
    //         if( productNode )
    //         {
    //             brandProducts.push( productNode.node );
    //         }
    //     }
    // }
    var brands = {};
    var products;

    for(var prop in g_quizProducts )
    {        
        if(prop.includes("-vendor"))
        {
            brands[prop] = g_quizProducts[prop];
        }
    }

    var prodAmt = Math.ceil(10 / Object.keys(brands).length);
    
    var product, productNode;
    var amt;

    // console.log("amt/////////////////////////")

    for(var brand in brands )
    {
        // console.log(brands[brand].length)
        amt = 0;
        for( var i = 0; i < brands[brand].length; i++ )
        {

            product     = brands[ brand ][i];
            
            productNode = g_productLookup[ product.id ];

            if( amt == 50 )
            {
                break;
            }
    
            if( productNode )
            {
                amt += 1;
                brandProducts.push( productNode.node );
            }
        }
    }

    return brandProducts;
}

function filterByDiet(products)
{
    var dietProducts = g_dietAccProducts;
    
    var acceptedProducts = products.filter(n => dietProducts.some(n2 => n.id == n2.id ));

    return acceptedProducts;
}

function getAllDietProducts()
{
    var products = [];
    var acceptedProducts = [];
    for (var name in g_quizProducts) 
    {
        if (name.includes("-diet")) 
        {
            products.push(g_quizProducts[name]);
        }
    }
    if(products.length > 1)
    {
        acceptedProducts = products.reduce((array1, array2) => array1.filter(n => array2.some(n2 => n.id == n2.id )));
    }
    else
    {
        for(aisle in g_quizProducts)
        {
            acceptedProducts = acceptedProducts.concat(g_quizProducts[aisle]);
        }
    }

    g_dietAccProducts = acceptedProducts;

    return g_dietAccProducts;

}

function GetDietProducts( qp, diet )
{
    console.log("global");
    // console.log(g_quizProducts)
    getAllDietProducts();
    var dietProducts    = [];
    var vendorCount     = {};
    var products        = g_quizProducts[diet + "-diet"];
    

    if( products && products.length > 0 )
    {
        for( var i = 0; i < products.length; i++ )
        {
            var product     = products[ i ];
            var productNode = g_productLookup[ product.id ];
    
            // if( dietProducts.length == 10 )
            // {
            //     break;
            // }
    
            if( VendorNotSeenOrDifferentToSelected( qp, vendorCount, product ) )
            {
                if( productNode )
                {
                    dietProducts.push( productNode.node );
                }
            }
    
            if( vendorCount[ product.vendor ] )
            {
                vendorCount[ product.vendor ] = vendorCount[ product.vendor ] + 1;
            }
            else
            {
                vendorCount[ product.vendor ] = 1;
            }
        }
    }

    // console.log("DIET PRODUCTS MARKUP@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@")
    // console.log(dietProducts)
    g_dietAccProductsMarkup = dietProducts;

    return dietProducts;
}

function GetAisleProducts( qp, aisle, type )
{
    
    var aisleProducts   = [];
    var vendorCount     = {};
    var products        = g_quizProducts[ aisle ];
    
    if( products && products.length > 0 )
    {
        if( type == "nonFood" )
        {
            for( var i = 0; i < products.length; i++ )
            {
                var product     = products[ i ];
                var productNode = g_productLookup[ product.id ];
        
                // if( aisleProducts.length == 10 )
                // {
                //     break;
                // }
        
                if( VendorNotSeenOrDifferentToSelected( qp, vendorCount, product ) )
                {
                    if( productNode )
                    {
                        aisleProducts.push( productNode.node );
                    }
                }
        
                if( vendorCount[ product.vendor.toLowerCase() ] )
                {
                    vendorCount[ product.vendor.toLowerCase() ] = vendorCount[ product.vendor.toLowerCase() ] + 1;
                }
                else
                {
                    vendorCount[ product.vendor.toLowerCase() ] = 1;
                }
            }
        
            return aisleProducts;
        }
        else
        {
            filteredProducts = filterByDiet(products)

            var rankedProducts = RankProductsBasedOnTag( filteredProducts );

            for( var i = 0; i < rankedProducts.length; i++ )
            {
                var product     = rankedProducts[ i ];
                var productNode = g_productLookup[ product.id ];

                if( productNode )
                {

                    // if( aisleProducts.length == 10 )
                    // {
                    //     aisleProducts.push( productNode.node );
                    //     break;
                    // }
            
                    if( VendorNotSeenOrDifferentToSelected( qp, vendorCount, product ) )
                    {
                        aisleProducts.push( productNode.node );
                    }

                    if( vendorCount[ product.vendor.toLowerCase() ] )
                    {
                        vendorCount[ product.vendor.toLowerCase() ] = vendorCount[ product.vendor.toLowerCase() ] + 1;
                    }
                    else
                    {
                        vendorCount[ product.vendor.toLowerCase() ] = 1;
                    }
                }
            }
        
            return aisleProducts;
        }
    }
    else
    {
        return [];
    }
}

function RankProductsBasedOnTag( products )
{
    var rankedProducts  = [];
    var qp              = ParseQP( );

    if( qp.diet && qp.diet.length > 0 )
    {
        var sorted  = [ ];
        var diets   = qp.diet.split( "," );

        products.forEach( function( product )
        {
            var tagCount = 0;
            
            diets.forEach( function( diet )
            {
                if( product.tags )
                {
                    var tags = product.tags.split( "," );
                    tags.forEach( function( tag )
                    {
                        tag = tag.toLowerCase().trim();
                        if( tag.includes( diet ) || diet.includes( tag ) || tag == diet )
                        {
                            tagCount++;
                        }
                    } );
                }
            } );
            
            product.rank = tagCount;
            rankedProducts.push( product );

            InsertionSort( sorted, product, QuizSorter, { "allowDuplicateKeys" : true } );
        } );
        
        rankedProducts = sorted;
    }
    else
    {
        rankedProducts = products;
    }

    return rankedProducts;
}

function GetAllBestSellerProducts( field )
{
    var allProducts   = [];   
    var products      = g_quizProducts[ field ];

    if( products && products.length > 0 )
    {
        for( var i = 0; i < products.length; i++ )
        {
            var product     = products[ i ];
            if( g_productLookup[ product.id ] )
            {
                var productNode = g_productLookup[ product.id ];
                allProducts.push( productNode.node );
            }
        }
    }

    return allProducts;
}

function VendorNotSeenOrDifferentToSelected( qp, vendorList ,product )
{
    var okay        = true;

    if( qp.vendor )
    {
        var vendors = qp.vendor.split( "," );
        for(var vendor in vendors)
        {
            vendor = vendors[vendor];
            vendor = vendor.split("-")[0];
            if( product.vendor.toLowerCase() == vendor.toLowerCase() && vendorList[ vendor.toLowerCase() ] >= 2 ||  vendorList[ product.vendor.toLowerCase() ] >= 2)
            {
                okay = false;
            }
        }
    }
    return okay;
}

function RenderProductsV2( randomBrandFromAnswers, ranomDietFromAnswers )
{
    if( randomBrandFromAnswers )
    {
        ReallyRenderProducts( "[data-for='vendor']", randomBrandFromAnswers );
    }
    if( ranomDietFromAnswers )
    {
        ReallyRenderProducts( "[data-for='diet']", ranomDietFromAnswers );
    }
}

function ReallyRenderProducts( selector, category, nodes, type, typevalue )
{
    // console.log("NODES ??????????????????????????????? FOR " + type )
    // console.log(nodes)

    if(typevalue)
    {
        // console.log(type + "////////////////")
        var products    = g_quizProducts[ category ];
        var target      = document.querySelector( selector );
        var idx         = 0;

        if(type == "diet" )
        {
            console.log("////////////////////////////////////////////////////////")
            console.log("////////////////////////////////////////////////////////")

            g_dietAccProductsMarkup.forEach( function( node )
            {
                if(target.childNodes.length < 10)
                {
                    target.appendChild( node);
                    g_dietAccProductsMarkup.splice(g_dietAccProductsMarkup.indexOf(node),1);
                }
                else
                {
                    
                }
            } );
        }
        else if( nodes )
        {
            nodes.forEach( function( node )
            {
                if(target.childNodes.length < 10)
                {
                    if(!document.getElementsByClassName("welleasy-result-product-section")[0].contains(node))
                    {
                        target.appendChild( node );
                    }
                }
            } );
        }
        else if( category )
        {
            for( var i = 0; i < products.length; i++ )
            {
                var product = products[ i ];
                var productNode = g_productLookup[ product.id ];
        
                // if( idx == 10 )
                // {
                //     break;
                // }
        
                if( productNode )
                {
                    target.appendChild( productNode.node );
                    idx++;
                }
            }
        }
        
        var parent = SearchParentsFor( target, "welleasy-quiz-products-results" );
        var title  = parent.querySelector( ".product-result-title" );

        var collectionName = "";
        if( typevalue && g_CollectionData[ typevalue ] )
        {
            collectionName = g_CollectionData[ typevalue ].title;
        }
        else
        {
            collectionName = typevalue
        }


        title.innerText = collectionName;
        


        parent.setAttribute( "data-typevalue", collectionName );
        AppendShowmore( collectionName );
        //ugh

        try
        {
            if( type && type == "aisle" )
            {
                initProductSlider( typevalue );
            }
            else if( type )
            {
                initProductSlider( type );
            }
            else
            {

            }

            ShowImages( selector );
        }
        catch ( e )
        {
            console.log( "error initialising sliders : ", e );
        }
        // document.querySelector(".loader").style.display = "none";
    }

}

function RandomCollection( field, qp )
{
	var randomValue = "";
	if( qp[ field ] )
	{
		var values 			= qp[ field ].split( "," );
		var randomNumber 	= Math.floor( Math.random( ) * ( ( values.length - 1 ) - 0 + 1 ) ) + 0;
		randomValue			= values[ randomNumber ]; 
	}

	return randomValue;
}

function GetBrandcollection( field, qp )//Here
{
    var values 			= qp[ field ].split( "," );
    var randomValue;
    var  breaker;
    for( var value in values )
    {
        randomValue = "";
        if( qp[ field ] )
        {
            var randomNumber 	= Math.floor( Math.random( ) * ( ( values.length - 1 ) - 0 + 1 ) ) + 0;
            randomValue			= values[ randomNumber ]; 
        }
    
        if( GetBrandProducts( randomValue ).length > 10 )
        {
            break;
        }
        else if( breaker > 5)
        {
            break;
        }
    }

	return randomValue;

}

function RandomAisleCollections( field, qp ) 
{
    var collections = {};
    var nonFoodAisles = [];
    var foodAisles = [];
  
    var randomAisles = ReallyGetRandomCollections( field, qp );
    randomAisles = randomAisles.split(",");
  
    var foodAislesValues;
    if ( qp["foodAisles"] ) 
    {
        foodAislesValues = qp["foodAisles"].split(",");
    }

    var nonFoodAislesValues;
    if ( qp["nonFoodAisles"] ) 
    {
        nonFoodAislesValues = qp["nonFoodAisles"].split(",");
    }

    randomAisles.forEach(function (randomAisle) 
    {
        if ( foodAislesValues && foodAislesValues.includes(randomAisle) ) 
        {
            foodAisles.push( randomAisle );
        } 
        else if ( nonFoodAislesValues && nonFoodAislesValues.includes(randomAisle) ) 
        {
            nonFoodAisles.push( randomAisle );
        }
    });
  
    collections.foodAisles = foodAisles;
    collections.nonFoodAisles = nonFoodAisles;
  
    return collections;
  }
  

function ReallyGetRandomCollections( field, qp )
{
    var values      = qp[ field ].split( "," );
    var collections = [];

    if( values.length > 4 )
    {
        // function GetRandomValue()
        // {
        //     if( collections.length < 4 )
        //     {
        //         var randomNumber = Math.floor( Math.random( ) * ( ( values.length - 1 ) - 0 + 1 ) ) + 0;
        //         if( !collections.includes( values[ randomNumber ] ) )
        //         {                   
        //             collections.push( values[ randomNumber ] );   
        //         }
        //         GetRandomValue();
        //     }
        // }
        // GetRandomValue();

        values.forEach(function(value)
        {
            if(collections.length < 4)
            {
                collections.push( value );
            }
        });

        collections = collections.toString();
    }
    else
    {
        collections = qp[ field ];
    }

    return collections;
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// don't allow the page to be reloaded purely from cache as the "logged in" status may have changed
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function BackButtonCacheBuster()
{
    window.addEventListener( "pageshow", function ( event )
    {
        var historyTraversal = event.persisted || ( typeof window.performance != "undefined" && window.performance.navigation.type === 2 );
        if ( historyTraversal )
        {
            // document.querySelector(".progress").style.display = "none";
            // var loadingText = document.querySelector('.loading-text');
            // loadingText.remove();
            $.ajax( {
                url: '?sections=cart-drawer-section,cart-products-auto-render,welleasy-new-cart-template-section',
                dataType: 'json',
                success: function ( data )
				{
                    $( "#cart-drawer-wellEasy" ).html( data[ 'cart-drawer-section' ] );
                },
            } );
        } 
		else 
		{
            FetchQuizResults();

			update_results_button();
			getQuestionsection();
        }
    } );
}

BackButtonCacheBuster( );




function getProductData() 
{
    var product_cards = document.querySelectorAll(".product_popup_btn");
    product_cards.forEach( product_card => 
    {
        product_card.addEventListener( "click", () => 
        {
            document.querySelector( ".welleasy_product_popop .popup_wrapper" ).innerHTML = "";

            var parent = SearchParentsFor( product_card, "product-card" );
            var url = parent.getAttribute( 'data-handle' );
            var variant_id = parent.getAttribute( 'data-variant-id' );

            var xhr = new XMLHttpRequest();
            xhr.open( "GET", url, true );
            xhr.onreadystatechange = function () 
            {
                if ( xhr.readyState === 4 && xhr.status === 200 ) 
                {
                    document.querySelector( "body" ).style.overflow = "hidden";
                    document.querySelector( ".welleasy_product_popop" ).classList.add( "open" );
                    document.querySelector( ".welleasy_product_overlay" ).classList.add( "open" );


                    var responseHTML  = xhr.responseText;

                    // Find specific HTML data within the responseHTML
                    var parser = new DOMParser();
                    var doc = parser.parseFromString( responseHTML, "text/html" );
                    var parsedHtml = doc.querySelector( ".product-detail" );
                    var addtocart_button = parsedHtml.querySelector( 'button[type="submit"]' );
                    
                    addtocart_button.classList.add( 'order-history-addToCart' );
                    addtocart_button.setAttribute( 'data-variant-id',variant_id );
                    parsedHtml.querySelector('.order-history-addToCart').classList.add("popup_addTocart");
                    document.querySelector( ".welleasy_product_popop .popup_wrapper" ).innerHTML = parsedHtml.innerHTML;
                    $(".welleasy_product_popop").animate({ scrollTop: 0 }, "fast");
                    $( ".popup_wrapper_loader" ).css('height',$( ".welleasy_product_popop .popup_wrapper" ).height());
                    setTimeout(() => 
                    {
                        document.querySelector( ".popup_wrapper_loader" ).classList.add( "hidden" );
                    }, 2000);
                    
                    var headers = document.querySelectorAll(".header--sticky.header__new");
                    headers.forEach((header) => 
                    {
                        header.style.display = "none";
                    });
                    var close_button = `
                        <h2 class="product_popup_close_button">X</h2>
                    `;
                          
                    var productgrid = document.querySelector( ".product-layout-grid" );
                    productgrid.innerHTML += close_button;


                    var atags = document.querySelectorAll( ".welleasy_product_popop .global-border-radius" );
                    for( var i = 0; i < atags.length; i++ )
                    {
                        var atag = atags[ i ];
                        atag.removeAttribute("href");
                        if( i > 0 )
                        {
                            atag.parentNode.parentNode.removeChild( atag.parentNode );
                        }
                    }


                    // close buttons click ( close popup )
                    var close_buttons = document.querySelectorAll( ".product_popup_close_button" );
                    close_buttons.forEach( close_button => 
                    {
                        close_button.addEventListener( "click", () => 
                        {
                            document.querySelector( ".welleasy_product_popop" ).classList.remove( "open" );
                            document.querySelector( ".welleasy_product_overlay" ).classList.remove( "open" );
                            document.querySelector( ".welleasy_product_popop .popup_wrapper" ).innerHTML = "";
                            document.querySelector( ".popup_wrapper_loader" ).classList.remove( "hidden" );
                            document.querySelector( "body" ).style.overflow = "auto";
                            var headers = document.querySelectorAll(".header--sticky.header__new");
                            headers.forEach((header) => 
                            {
                                header.style.display = "block";
                            });
                        });
                    });

                    //  ( close popup funcation )
                    var welleasy_product_popop = document.querySelector( ".welleasy_product_overlay.open" );

                    welleasy_product_popop.addEventListener( "click", () => 
                    {
                        welleasy_product_popop.classList.remove( "open" );
                        document.querySelector( ".welleasy_product_popop" ).classList.remove( "open" );
                        document.querySelector( ".popup_wrapper_loader" ).classList.remove( "hidden" );
                        document.querySelector( ".welleasy_product_popop .popup_wrapper" ).innerHTML = "";
                        document.querySelector( "body" ).style.overflow = "auto";
                        var headers = document.querySelectorAll(".header--sticky.header__new");
                        headers.forEach((header) => 
                        {
                            header.style.display = "block";
                        });
                    });
                
                    var qtySelect = document.querySelector( ".welleasy_product_popop.open #quantity-proxy" );
                    qtySelect.addEventListener( "change", function( e )
                    {
                        HandleModalQtyChange( e.currentTarget );
                    } );

            
                    // $('.product-detail__images').slick({
                    //     dots: false,
                    //     infinite: false,
                    //     slidesToShow: 1,
                    //     slidesToScroll: 1,
                    //     prevArrow: '<button class="slick-prev slick-arrow" aria-label="prev"><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"></path><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"></path></svg></button>',
                    //     nextArrow: '<button class="slick-next slick-arrow" aria-label="next"><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"></path><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"></path></svg></button>'
                    // });
                      
                    
                }
            };
            xhr.send();
            
        });
       

    });


}
 
function HandleModalQtyChange( select )
{
    var parent  = select.parentNode;
    var input   = parent.querySelector( "#Quantity" );
    input.value = select.value;
}